import SwapVertIcon from '@mui/icons-material/SwapVert';
import { Button, Typography } from '@mui/material';
import React from 'react';

interface JobQueueHeaderProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onAddJob: () => void;
  onSortClick: () => void;
}

const JobQueueHeader: React.FC<JobQueueHeaderProps> = ({
  searchValue,
  onSearchChange,
  onAddJob,
  onSortClick,
}) => {
  return (
    <div className="job-queue-header">
      {/* Search and Actions */}
      <div className="job-queue-actions">
        <Typography
          variant="h4"
          sx={{
            color: '#161719',
            fontFamily: 'Red Hat Display Bold',
            fontSize: '16px',
            fontWeight: 'semi-bold',
          }}>
          Job Queue
        </Typography>

        <div className="action-buttons">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="job-queue-search"
              style={{
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontFamily: 'Red Hat Display Medium',
                fontSize: '14px',
                outline: 'none',
                padding: '8px 12px',
              }}
            />
          </div>
          <Button
            onClick={onSortClick}
            sx={{
              '&:hover': {
                backgroundColor: '#f9fafb',
              },
              backgroundColor: 'transparent',
              border: '1px solid #e5e7eb',
              borderRadius: '6px',
              color: 'black',
              marginRight: '8px',
              minWidth: 'auto',
              padding: '8px',
            }}>
            <SwapVertIcon
              sx={{
                fontSize: '15px',
              }}
            />
          </Button>

          <Button
            onClick={onAddJob}
            sx={{
              '&:hover': {
                backgroundColor: '#374151',
              },
              backgroundColor: '#161719',
              borderRadius: '6px',
              color: 'white',
              fontFamily: 'Red Hat Display Medium',
              fontSize: '14px',
              fontWeight: 'medium',
              height: '32px',
              padding: '8px 16px',
              textTransform: 'none',
            }}>
            + Add Job
          </Button>
        </div>
      </div>
    </div>
  );
};

export default JobQueueHeader;
